import { setMirroringModeAction as setMirroringModeOperation } from 'editor/src/store/design/slice';

export default setMirroringModeOperation;
